import { getToolName, isToolUIPart, type UIMessage } from "ai";

export function patchPendingWriteToolProposalInMessages({
  messages,
  toolCallId,
  isWriteToolName,
  proposalPatch,
}: {
  messages: UIMessage[];
  toolCallId: string;
  isWriteToolName: (toolName: string) => boolean;
  proposalPatch: Record<string, unknown>;
}): UIMessage[] {
  if (!toolCallId) return messages;

  let changed = false;
  const next = messages.map((message) => {
    if (message.role !== "assistant") return message;
    let messageChanged = false;
    const parts = message.parts.map((part) => {
      if (!isToolUIPart(part)) return part;
      if (part.toolCallId !== toolCallId) return part;
      if (!isWriteToolName(getToolName(part))) return part;
      const prevInput =
        part.input && typeof part.input === "object"
          ? (part.input as Record<string, unknown>)
          : {};
      messageChanged = true;
      return {
        ...part,
        input: { ...prevInput, ...proposalPatch },
      } as typeof part;
    });
    if (!messageChanged) return message;
    changed = true;
    return { ...message, parts };
  });

  return changed ? next : messages;
}
